import { PulseBroadcastChannel } from '@pulse/browser-shared';
import { InjectionToken } from '@pulse/common';

export type SettingsCacheBroadcastMessage = {
    type: string;
    tag: string;
};

export const SettingsCacheBroadcastChannelToken = new InjectionToken<
    PulseBroadcastChannel<SettingsCacheBroadcastMessage>,
    'SETTINGS_CACHE_BC'
>('SETTINGS_CACHE_BC');
